import http from '../../http'

const API_URL = "activity-health" 

class ActivityHealthAPI {

  async save(program) {
    const response = await http(`${API_URL}/save`, 'POST', program)
    return response
  }
  async saveEvidence(program) {
    const response = await http(`activity-health-evidence/save`, 'POST', program)
    return response
  }
  

  async getEvidence(id) {
    const response = await http(`activity-health-evidence/show/${id}`)
    return response || null
  } 

  async updateEvidence(id, program) {
    const response = await http(`activity-health-evidence/update/${id}`, 'PUT', program)
    return response
  }



  async getTraining(companyID) {
    const response = await http(`${API_URL}/index/${companyID}`)
    return response || null
  } 

  async getAll(companyID, page) {
    const response = await http(`${API_URL}/index/${companyID}?page=${page}`)
    return response || null
  } 

  async get(programID) {
    const response = await http(`${API_URL}/show/${programID}`)
    return response || null
  }
 
  async update(id, program) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', program)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }
   
}

export default new ActivityHealthAPI()